import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "airtable-embed",
  src: "https://airtable.com/embed/shrTLQ4aRy98s4Kjj?backgroundColor=red&layout=card&viewControls=off",
  frameborder: "0",
  onmousewheel: "",
  width: "100%",
  height: "533",
  style: {"background":"transparent","border":"1px solid #ccc"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("iframe", _hoisted_1))
}